module.exports = __webpack_public_path__ + "img/dpbb.98d5ff2d.png";